
import style from './loading.module.css';

const Loading = () => {
  return (
    <div className={style.ldsEllipsis}><div></div><div></div><div></div><div></div></div>
  )
}
export default Loading;